export const ANNOTATION_TYPES = {
  Highlight: 1,
  Snippet: 2,
  Manual: 3
};

export const PIECE_TYPES = {
  snippet: 1,
  option: 2,
  criterion: 3
};

export const WORKSPACE_TYPES = {
  more: -1,
  table: 1
};

export const TABLE_CELL_TYPES = {
  topLeft: 0,
  columnHeader: 1,
  rowHeader: 2,
  regularCell: 3
};

export const RATING_TYPES = {
  noRating: -1,
  positive: 1,
  negative: 2,
  info: 3
};

export const TIMESTAMP_TYPES = {
  annotation: 1,
  inSidebar: 2
};



// WEBPACK FOOTER //
// ../shared-components/src/shared/types.js